export const EMBED_IMAGE_IN_RTE = 'EMBED_IMAGE_IN_RTE';
export const OPEN_IMAGE_FILE_PICKER = 'OPEN_IMAGE_FILE_PICKER';